/**
 * Fiscal Registration
 * Fiskal Cloud Keycloak API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ManagedObjectDTO } from './managed-object-dto';


/**
 * Defines a user body
 */
export interface UserBodyAllOfDTO { 
    /**
     * roles
     */
    roles: Array<string>;
    managedObject?: ManagedObjectDTO;
}

export class ClsUserBodyAllOfDTO { 
    /**
     * roles
     */
    roles: Array<string> = undefined;
    managedObject?: ManagedObjectDTO = undefined;
}

